module.exports = __webpack_public_path__ + "img/spyder-icon.2dad69fa.svg";